import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NsNumberInputConstants } from './ns-number-input.constants';
import { Observable } from 'rxjs';

@Component({
  selector: 'ns-number-input',
  templateUrl: './ns-number-input.component.html',
  styleUrls: ['./ns-number-input.component.scss']
})
export class NsNumberInputComponent implements OnInit {

  @Input() minValue = 0;
  @Input() maxValue = 999999;
  @Input() maxLength?: number;
  @Input() brandColor?: string;
  @Input() control: UntypedFormControl = new UntypedFormControl(null);
  @Input() allowOnlyDigits?: boolean;
  @Input() disabled: boolean;
  @Input() allowDecimals?: boolean;
  @Input() invisible?: boolean;
  @Input() leftIcon?: string;
  @Output() callback$: EventEmitter<number> = new EventEmitter();
  @Input() $reset: Observable<void> = new Observable<void>();
  @Output() errorMessageKey$: EventEmitter<number> = new EventEmitter();
  @Input() classes = '';
  @Input() placeholder = '';
  @Input() customPlaceholder = '';
  @Input() valid = true;
  hidePlaceholder = false;

  _previousValue = null;
  readonly INSERT_TEXT_KEY = 'insertText';
  readonly DELETE_CONTENT_BACKWARD_KEY = 'deleteContentBackward';

  ngOnInit() {
    this.$reset.subscribe(() => {
      this._previousValue = null;
      this.control.setValue(this._previousValue);
    });
  }

  onType(event: InputEvent | any): void {
    if (event.inputType === this.DELETE_CONTENT_BACKWARD_KEY && this._previousValue < 10) {
      this._previousValue = null;
    }

    if (!(event.inputType === this.INSERT_TEXT_KEY || event.inputType === this.DELETE_CONTENT_BACKWARD_KEY)) {
      this.control.setValue(this._previousValue);
    }

    if (isNaN(parseInt(event.data, 10)) && (event.inputType !== this.DELETE_CONTENT_BACKWARD_KEY)) {
      this.control.setValue(this._previousValue);
    }

    if (!this.allowDecimals && event.data === '.') {
      this.control.setValue(this._previousValue);
    }

    if (this.allowOnlyDigits && !this.isDigit(event.data)) {
      this.control.setValue(this._previousValue);
    }

    if (this.control.value > this.maxValue) {
      this.errorMessageKey$.emit(NsNumberInputConstants.MAX_VALUE_EXCEEDED_ERROR_KEY);
    }

    if (this.control.value < this.minValue) {
      this.errorMessageKey$.emit(NsNumberInputConstants.MIN_VALUE_EXCEEDED_ERROR_KEY);
    }

    if (this.control.valid) {
      this._previousValue = this.control.value;
      this.callback$.emit(this.control.value);
    }

    this.hidePlaceholder = this.control.value;

  }

  private isDigit(value): boolean {
    return value !== '-' && value !== '+' &&
      value !== 'e' && value !== 'E' &&
      typeof parseInt(value, 10) === 'number';
  }

}

